// toast-template-registry.service.ts
import { Injectable, TemplateRef } from '@angular/core';

@Injectable()
export class ToastTemplateRegistryService {
  private templates: { [key: string]: TemplateRef<any> } = {};

  registerTemplate(key: string, template: TemplateRef<any>): void {
    this.templates[key] = template;
  }

  getTemplate(key: string): TemplateRef<any> | null {
    return this.templates[key] || null;
  }
}
